/**
 * Administrator form: shared pure validation.
 *
 * `validateDraft` mirrors the exact rules the two flat pages (`AddAdmin` /
 * `EditAdmin`) enforced inline: name, email and role required, plus an email-format
 * check via the shared `isValidEmail`; the LinkedIn URL is optional but must be
 * a member profile when given (`linkedInUrlError`, the user forms' rule, #617). Pure (no React/Redux/fetch) so it is
 * unit-tested directly and reused by both slices' selectors and sagas.
 */
import { linkedInUrlError } from '@/shared/linkedin/linkedin-url';
import { isValidEmail } from '@/utils/validation';

import type { AdminDraft, ValidationErrors } from './administrator-draft.model';

export function validateDraft(draft: AdminDraft): ValidationErrors {
  const errors: ValidationErrors = {};

  if (!draft.firstName.trim()) errors.firstName = 'First name is required.';
  if (!draft.lastName.trim()) errors.lastName = 'Last name is required.';

  if (!draft.email.trim()) {
    errors.email = 'Email is required.';
  } else if (!isValidEmail(draft.email)) {
    errors.email = 'Please enter a valid email address.';
  }

  if (!draft.role) errors.role = 'Role is required.';

  const linkedinUrl = linkedInUrlError(draft.linkedinUrl);
  if (linkedinUrl) errors.linkedinUrl = linkedinUrl;

  return errors;
}
